import requests from '@/utils/requests';

/**
 * 项目列表接口
 * @param {*} data
 */
export function projectList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/project/list',
    method: 'post',
    data
  });
}

/**
 * 用户参与的项目列表接口
 * @param {*} data
 */
export function projectInvolvedList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/project/involvedList',
    method: 'post',
    data
  });
}

/**
 * 添加项目接口
 * @param {*} data
 */
export function projectAdd (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/project/add',
    method: 'post',
    data
  });
}

/**
 * 修改项目接口
 * @param {*} data
 */
export function projectModify (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/project/modify',
    method: 'post',
    data
  });
}

/**
 * 删除项目接口
 * @param {*} data
 */
export function projectDelete (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/project/delete',
    method: 'post',
    data
  });
}

/**
 * 删除项目接口
 * @param {*} data
 */
export function projectDetail (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/project/detail',
    method: 'post',
    data
  });
}

/**
 * Jira项目接口
 * @param {*} data
 */
export function jiraProjectList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/project/jiraProjectList',
    method: 'post',
    data
  });
}

/**
 * 今日待办内容接口
 * @param {*} data
 */
export function getDailyWorkInfo (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/project/getDailyWorkInfo',
    method: 'post',
    data
  });
}
